import { memo } from "react";

import useAnalytics from "effect/use_analytics";

import ErrorPage from "./Error";

// -----------------------------------------------------------------------------

const ComingSoonPage = memo(function ComingSoonPage() {
  useAnalytics("Meta: Coming Soon");

  //
  return <ErrorPage override="coming-soon" />;
});

export default ComingSoonPage;
